import { Grid, Paper, Typography } from "@material-ui/core";
// import Axios from "axios";
import "date-fns/locale/pt-BR";
import React from "react";

const ClienteResumo = (props) => {
	return (
		<React.Fragment>
			<Paper className="p-1 mb-1">
				<Typography variant="caption" className="p-0 m-0" gutterBottom>
					Cliente
				</Typography>
				<Grid container spacing={3}>
					<Grid item md={12}>
						<Typography variant="body2" className="p-0 m-0" gutterBottom>
							<b>Nome:</b> {props.cliente.nome} | <b>Documento: </b>
							{props.cliente.documento} | <b>Tipo: </b>
							{props.cliente.tipo_consumidor} | <b>Gênero: </b>
							{props.cliente.genero}
						</Typography>
					</Grid>
				</Grid>
			</Paper>
			<Paper className="p-1 mb-1">
				<Typography variant="caption" className="p-0 m-0" gutterBottom>
					Endereço de entrega
				</Typography>
				<Grid container spacing={3}>
					<Grid item md={12}>
						<Typography variant="body2" className="p-0 m-0" gutterBottom>
							{props.cliente.endereco_entrega},{" "}
							{props.cliente.complemento_entrega !== ""
								? props.cliente.complemento_entrega
								: ""}
							, {props.cliente.bairro_entrega} -{" "}
							{props.cliente.municipio_entrega}/{props.cliente.estado_entrega} -{" "}
							{props.cliente.cep_entrega}
						</Typography>
					</Grid>
				</Grid>
			</Paper>
		</React.Fragment>
	);
};

export default ClienteResumo;
